import type {ReactElement} from "react";
import BrandIcon from "~/icons/svg/BrandIcon.svg?react";
import CompanyIcon from "~/icons/svg/CompanyIcon.svg?react";
import {Tag} from "~/components/tag/Tag";
import {SUPPLIER_ENTITY_TYPE_LABEL} from "~/pages/supplier-360/constants/supplierEntityLabels";
import type {SupplierEntityType} from "~/pages/supplier-360/types/Supplier360Types";

const ENTITY_TYPE_ICON: Record<SupplierEntityType, ReactElement> = {
    company: <CompanyIcon/>,
    brand: <BrandIcon/>,
};

type SupplierEntityTypeTagProps = {
    entityType: SupplierEntityType;
};

export function SupplierEntityTypeTag({entityType}: SupplierEntityTypeTagProps) {
    return (
        <Tag
            size="small"
            variant="outlined"
            color="default"
            icon={ENTITY_TYPE_ICON[entityType]}
            label={SUPPLIER_ENTITY_TYPE_LABEL[entityType]}
        />
    );
}
